import { render, staticRenderFns } from "./vendorsTable.vue?vue&type=template&id=1c72fbe0&scoped=true&"
import script from "./vendorsTable.vue?vue&type=script&lang=js&"
export * from "./vendorsTable.vue?vue&type=script&lang=js&"
import style0 from "./vendorsTable.vue?vue&type=style&index=0&id=1c72fbe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72fbe0",
  null
  
)

export default component.exports